import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Convenio } from '@interfaces/convenio.interface';
import { ConveniosService } from '@providers/convenios.service';
import { Observable, from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConvenioResolver implements Resolve<Convenio> {
  constructor(private conveniosService: ConveniosService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Convenio> {
    const idVirtual = route.queryParams?.IdVirtual;

    if (idVirtual) {
      return from(
        this.conveniosService
          .obtenerHomologacionConvenio(idVirtual)
          .then((idVirtual) => {
            const cn = idVirtual ? idVirtual : route.queryParams?.cn;
            return this.conveniosService
              .obtenerParametrosDelConvenio(cn, !idVirtual)
              .toPromise();
          })
      );
    } else {
      const cn = route.queryParams?.cn;
      return this.conveniosService.obtenerParametrosDelConvenio(cn);
    }
  }
}
